import React, { useEffect, useState, useRef } from "react";
import { useRecruiter } from "../context/RecruiterContext.tsx";
import RecruiterOnboarding from "../components/recruiterOnboarding.tsx";
import CandidateOnboarding from "../components/canidatesOnboarding.tsx";

export function Onboarding() {
    const [onboardingType, setOnboardingType] = useState(0);
    const isRecruiter = useRecruiter();
    const candidateFormRef = useRef<HTMLFormElement>(null);


    useEffect(() => {
        if (isRecruiter.onBoarded) {
            // Redirect to the dashboard
            window.location.href = '/?message=' + encodeURIComponent(btoa('You are already a customer.'));
        }
    }, [isRecruiter.onBoarded]);

    function handleCandidateOnboarding(event: React.FormEvent) {
        event.preventDefault();
        if (candidateFormRef.current) {
            const formData = new FormData(candidateFormRef.current);

            fetch('/api/canidateOnboarding', {
                method: 'POST',
                body: formData,
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
                    // Redirect to the dashboard
                    const message = 'Signed up successfully.';
                    const encodedMessage = btoa(message);
                    window.location.href = '/?message=' + encodeURIComponent(encodedMessage);
                })
                .catch((error) => {
                    const messageElement = document.getElementById('message');
                    if (messageElement) {
                        messageElement.innerText = 'An error occurred. Please try again.' + error;
                    }
                });
        }
    }

    return (
        <div className="container mx-auto p-4 flex justify-center items-center h-screen">
            {onboardingType === 0 ? (
                <div className="flex flex-col items-center">
                    <h1 className="text-2xl mb-4">Are you a candidate or a recruiter?</h1>
                    <div className="flex space-x-4">
                        <button
                            className="bg-blue-500 text-white px-4 py-2 rounded"
                            onClick={() => setOnboardingType(1)}
                        >
                            I am a candidate
                        </button>
                        <button
                            className="bg-green-500 text-white px-4 py-2 rounded"
                            onClick={() => setOnboardingType(2)}
                        >
                            I am a recruiter
                        </button>
                    </div>
                </div>
            ) : onboardingType === 1 ? (
                <CandidateOnboarding formRef={candidateFormRef} handleCandidateOnboarding={handleCandidateOnboarding} userId={isRecruiter.userId || ""} />
            ) : (
                <RecruiterOnboarding userId={isRecruiter.userId || ""} />
            )}
        </div>
    );
};